import { FolderDocuments, GroupedDocuments } from '@/types/documents';
import { Document } from '@/actions/dtos/document';

export const groupDocumentsIntoFolders = (documents: Document[]): GroupedDocuments => {
  const rootFolders: FolderDocuments[] = [];
  const rootDocuments: Document[] = [];

  documents.forEach((doc) => {
    if (!doc.path) {
      rootDocuments.push(doc);
      return;
    }

    const pathSegments = doc.path.split('/');
    let currentFolders = rootFolders;

    pathSegments.forEach((segment, index) => {
      let folder = currentFolders.find((f) => f.folderName === segment);
      if (!folder) {
        folder = {
          folderName: segment,
          documents: [],
          subfolders: [],
        };
        currentFolders.push(folder);
      }

      if (index === pathSegments.length - 1) {
        folder.documents.push(doc);
      } else {
        currentFolders = folder.subfolders;
      }
    });
  });

  return { rootFolders, rootDocuments };
};
